(() => {

    // Block Name
    const blockName = 'greengzm-map';

    // Variables
    let method = 'front';
    if (document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin')) {
        method = 'wp-admin';
    }
    // -- end

    // Custom methods

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined) block = block[0].querySelector(`.block-${blockName}`);
        if (block === false || block === null) return;

        // Block Code Here
        var $ = jQuery.noConflict();

        $(document).ready(function () {
            pageHeaderSpacer();
        });
        $(window).on('resize', function () {
            pageHeaderSpacer();
        });

        function pageHeaderSpacer() {
            const pageheaderHeight = $('.page-header').length ? $('.page-header').outerHeight() : 0;
            const infobarHeight = $('.c-infobar').length ? $('.c-infobar').outerHeight() : 0;
            const breadcrumbsHeight = ('.breadcrumbs').length ? $('.breadcrumbs').outerHeight() : 0;

            // const blockMapFullHeight = pageheaderHeight + infobarHeight + breadcrumbsHeight;
            const blockMapFullHeight = pageheaderHeight + infobarHeight;


            $('.js-height-sidebar, .js-height-view').css('height', 'calc(100vh - ' + blockMapFullHeight + 'px)');

            // const blockMapFullHeightHalf = blockMapFullHeight / 2;
            // if ($(window).outerWidth() >= 768) {
            //     $('.js-height-sidebar, .js-height-view').css('height', 'calc(100vh - ' + blockMapFullHeight + 'px)');
            // } else {
            //     $('.js-height-sidebar').css('height', 'calc(50vh - ' + blockMapFullHeightHalf + 'px)');
            //     $('.js-height-view').css('height', 'calc(50vh - ' + blockMapFullHeightHalf + 'px)');
            // }
        }

        /**
         * LEAFLET INIT
         */

            // Markers data
        let markersData = block.id.replaceAll('-', '') + '_markers';
        let borderData = block.id.replaceAll('-', '') + '_border';
        let voivodeshipsData = block.id.replaceAll('-', '') + '_voivodeships';
        let regionsData = block.id.replaceAll('-', '') + '_regions';
        let labelData = block.id.replaceAll('-', '') + '_labels';


        let activeLayers = new Map();
        // let layerGroup = L.LayerGroup([]);

        markersData = window[markersData];
        borderData = window[borderData];
        voivodeshipsData = window[voivodeshipsData];
        regionsData = window[regionsData];
        labelData = window[labelData];


        labelData = labelData.map(el => Number.isInteger(el.code) ? {...el, code: el.code.toString()} : el);


        let highlightPopPark;
        let highlightedMarker = null;
        // Add a place to save markers
        let markers = {};
        let showParks = true;


        // Attribution
        var mbAttr = 'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';
        var mbUrl = 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw';


        // Map layers
        var CartoClassic = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
            attribution: '&copy; <a href="https://carto.com/attributions">CARTO</a>'
        });
        var osm = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        });
        var satellite = L.tileLayer(mbUrl, {
            id: 'mapbox/satellite-v9',
            tileSize: 512,
            zoomOffset: -1,
            attribution: mbAttr
        });

        let CartoDb = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}' + (L.Browser.retina ? '@2x.png' : '.png'), {
            attribution: '&copy; <a href="https://carto.com/attributions">CARTO</a>',
            //	className: 'carto',
            subdomains: 'abcd'
        });

        // let GoogleSatellite = L.tileLayer('https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
        //     maxZoom: 16,
        // });

        let GoogleSatellite = L.tileLayer('https://infogzm.metropoliagzm.pl/iframes/tiles/get_orto.php?z={z}&x={x}&y={y}', {
            maxZoom: 16,
            attribution: '&copy; Ortofotomapa GUGiK',
        });

        // Generate map
        let startZoom = 10;
        if(window.matchMedia('only screen and (max-width: 768px)').matches){
            startZoom = 9;
        }
        var map = L.map('mapGreenGZM', {
            center: [50.316735, 18.93359],
            zoom: startZoom,
            minZoom: 9,
            maxZoom: 17,
            layers: [CartoDb],
            maxBounds: [
                [51.5, 16.00],
                [49.0, 22.00]
            ],
        });

        var baseLayers = {
            'Carto': CartoDb,
            // 'OpenStreetMap': osm,
            'Satellite': GoogleSatellite,
        };

        let timer;

        let ovlPane = map.createPane('ovl');
        let shadowPane = map.createPane('shadowx');
        let woj = map.createPane('woj');
        let borders = map.createPane('borders');
        let waters = map.createPane('waters');
        let wms = map.createPane('wms');
        woj.style.zIndex = 401;
        borders.style.zIndex = 402;
        waters.style.zIndex = 403;
        wms.style.zIndex = 405;
        ovlPane.style.zIndex = 410;
        shadowPane.style.zIndex = 415;

        let shadow = L.geoJSON(borderData, {
            style: {
                fillOpacity: 1.0,
                fillColor: 'white',
                "weight": 0,
                clickable: false,
                interactive: false
            },
            className: 'granica_class',
            pane: 'shadowx',
            smoothFactor: 0.01
        }).addTo(map);


        let gzmLabels = L.layerGroup();
        // console.log(labelData);
        labelData.forEach(obj => {
            L.marker(
                new L.LatLng(
                    obj.location[0],
                    obj.location[1]
                ),
                {
                    icon: createLabelIcon(obj.label)
                }
            ).addTo(gzmLabels);
        });

        function createLabelIcon(labelText, html = '') {
            if (labelText == undefined) {
                labelText = 'b.d.';
            }
            let clName = labelText.toString().replace("<br>", "_");
            clName = clName.replace("Siemianowice_Śląskie", "Siemianowice_Śl");
            let content = '<span>' + labelText.toString() + '</span>';
            if (html != '') {
                content += html;
            }
            return L.divIcon({
                iconSize: [100, 50],
                iconAnchor: [50, 25],
                // iconSize: [null],
                // iconAnchor: [15, 5],
                className: "labelClass markerCenterForce  " + clName,
                html: content
            })
        }

        let wojThick = L.geoJson(voivodeshipsData, {
            style: function () {
                return {
                    weight: 6,
                    opacity: 0.15,
                    color: '#bb57ff',
                    dashArray: '',
                    fillColor: 'rgb(32, 43, 79)',
                    fillOpacity: 0,
                    smoothFactor: 0.01,
                    clickable: false,
                    interactive: false
                }
            },
            className: 'b_woj0',
            pane: 'woj'
        }).addTo(map);

        let wojThin = L.geoJson(voivodeshipsData, {
            style: function () {
                return {
                    weight: 1.0,
                    opacity: 1,
                    color: '#777',
                    dashArray: '3 4',
                    fillColor: 'rgb(32, 43, 79)',
                    fillOpacity: 0,
                    smoothFactor: 0.01,
                    lineCap: 'square',
                    clickable: false,
                    interactive: false
                }
            },
            className: 'b_woj1',
            pane: 'woj'
        }).addTo(map);

        let gzm = L.geoJSON(regionsData, {
            style: function () {
                return {
                    opacity: 1,
                    color: "#000",
                    weight: 1.2,
                    dashArray: '3',
                    fillOpacity: 0,
                    smoothFactor: 0.05,
                    clickable: false,
                    interactive: false
                }
            },
            pane: 'ovl'
        }).addTo(map);


        // SHADOW xD
        let svg = shadowPane.firstChild;
        svgFilter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
        svgBlur = document.createElementNS('http://www.w3.org/2000/svg', 'feGaussianBlur');
        svgComposite = document.createElementNS('http://www.w3.org/2000/svg', 'feComposite');
        svgOffset = document.createElementNS('http://www.w3.org/2000/svg', 'feOffset');
        svgTransfer = document.createElementNS('http://www.w3.org/2000/svg', 'feComponentTransfer');
        svgFuncA = document.createElementNS('http://www.w3.org/2000/svg', 'feFuncA');
        svgMerge = document.createElementNS('http://www.w3.org/2000/svg', 'feMerge');
        svgMergeNode0 = document.createElementNS('http://www.w3.org/2000/svg', 'feMergeNode');
        svgMergeNode1 = document.createElementNS('http://www.w3.org/2000/svg', 'feMergeNode');
        svgFilter.setAttribute('id', 'dropshadow');
        svgBlur.setAttribute('stdDeviation', 10);
        svgBlur.setAttribute('in', 'SourceAlpha');
        svgOffset.setAttribute('result', 'offsetblur');
        svgOffset.setAttribute('dx', '0');
        svgOffset.setAttribute('dy', '0');
        svgFuncA.setAttribute('type', 'linear');
        svgFuncA.setAttribute('slope', '0.6');
        svgMergeNode1.setAttribute('in', 'SourceGraphic');
        svgComposite.setAttribute('operator', 'out');
        svgComposite.setAttribute('in2', 'SourceGraphic');
        svgFilter.appendChild(svgBlur);
        svgFilter.appendChild(svgOffset);
        svgTransfer.appendChild(svgFuncA);
        svgFilter.appendChild(svgTransfer);
        svgFilter.appendChild(svgMerge);
        svgMerge.appendChild(svgMergeNode0);
        svgMerge.appendChild(svgMergeNode1);
        svgFilter.appendChild(svgComposite);
        svg.appendChild(svgFilter);
        document.querySelector(".leaflet-shadowx-pane svg > g path").setAttribute("filter", "url(#dropshadow)");
        map.addLayer(gzm);

        // let pkt_skwer;

        let pkt_park = new L.geoJson(markersData, {
            pane: 'ovl',
            onEachFeature: pop_pkt_park,
            pointToLayer: function (feature, latlng) {
                let context = {
                    feature: feature,
                    variables: {}
                };
                return L.marker(latlng, marker_park(feature));
            },
        }).addTo(map);

        pkt_park.eachLayer(function (layer) {
            layer._icon.name = layer.feature.properties.name;
        });

        function marker_park() {
            return {
                icon: L.icon({
                    iconUrl: '/wp-content/themes/infogzm/img/icons/marker-green.png',
                    className: 'marker_park',
                    iconAnchor: [13, 40],
                    popupAnchor: [0, -25],
                    iconSize: [26, 40]
                }),
            }
        };

        function pop_pkt_park(feature, layer) {
            layer.on({
                mouseout: function (e) {
                    if (typeof layer.closePopup == 'function') {
                        layer.closePopup();
                    } else {
                        layer.eachLayer(function (feature) {
                            feature.closePopup()
                        });
                    }
                },
                mouseover: highlightFeaturePark,
                click: clickFeaturePark
            });
            let popupContent = '<div class="title">' + feature.properties.name + '</div>';
            if (feature.properties.thumbnail != false) {
                popupContent = '<div class="frame"><img src="' + feature.properties.thumbnail + '" ><div class="title">' + feature.properties.name + '</div></div>';
            }
            let customOptions = {
                'maxHeight': '450',
                'className': 'custom'
            };
            layer.bindPopup(popupContent, customOptions);
        }


        let pkt_skwer = new L.geoJson(skwery_pkt, {
            // pane: 'marker',
            onEachFeature: pop_pkt_skwery,
            pointToLayer: function (feature, latlng) {
                let context = {
                    feature: feature,
                    variables: {}
                };
                return L.marker(latlng, marker_skwer(feature));
            },
        }).addTo(map);

        pkt_skwer.eachLayer(function (layer) {
            // layer._icon.name = layer.feature.properties.Nazwa;
            layer._icon.style.display = 'none';
        });

        function marker_skwer() {
            return {
                icon: L.icon({
                    iconUrl: '/wp-content/themes/infogzm/img/icons/lemon_circle.svg',
                    className: 'marker_skwer',
                    iconAnchor: [6.5, 6.5],
                    popupAnchor: [110, 0],
                    iconSize: [13, 13]
                }),
            }
        };

        function pop_pkt_skwery(feature, layer) {
            layer.on({
                mouseout: function (e) {
                    if (typeof layer.closePopup == 'function') {
                        layer.closePopup();
                    } else {
                        layer.eachLayer(function (feature) {
                            feature.closePopup()
                        });
                    }
                },
                mouseover: highlightFeaturePark,
            });
            let popupContent = '<div class="title title--skwer">' + feature.properties.Nazwa + '</div>';

            let customOptions = {
                'maxHeight': '450',
                'className': 'custom__skwer'
            };
            layer.bindPopup(popupContent, customOptions);
        }

        let pkt_zoo = new L.geoJson(mosiry, {
            filter: function (feature, layer) {
                if (feature.properties) {
                    return feature.properties.typ === '1B' || feature.properties.typ === '1A';
                }
                ;
                return false;
            },
            // pane: 'marker',
            onEachFeature: pop_pkt_zoo,
            pointToLayer: function (feature, latlng) {
                let context = {
                    feature: feature,
                    variables: {}
                };
                return L.marker(latlng, marker_zoo(feature));
            },
        }).addTo(map);

        pkt_zoo.eachLayer(function (layer) {
            // layer._icon.name = layer.feature.properties.Nazwa;
            layer._icon.style.display = 'none';
        });

        function marker_zoo(feature) {
            switch (feature.properties.typ) {
                case '1B':
                    return {
                        icon: L.icon({
                            iconUrl: '/wp-content/themes/infogzm/img/icons/elephant_color.svg',
                            className: 'marker_ogrody',
                            iconAnchor: [12, 12],
                            popupAnchor: [85, 0],
                            iconSize: [24, 24]
                        }),
                    };
                    break;
                case '1A':
                    return {
                        icon: L.icon({
                            iconUrl: '/wp-content/themes/infogzm/img/icons/palm_color.svg',
                            className: 'marker_ogrody',
                            iconAnchor: [12, 12],
                            popupAnchor: [85, 0],
                            iconSize: [24, 24]
                        }),
                    }
                    break;
            }
        };


        function pop_pkt_zoo(feature, layer) {
            layer.on({
                mouseout: function (e) {
                    if (typeof layer.closePopup == 'function') {
                        layer.closePopup();
                    } else {
                        layer.eachLayer(function (feature) {
                            feature.closePopup()
                        });
                    }
                },
                mouseover: highlightFeaturePark,
            });
            let popupContent = '<div class="title title--zoo">' + feature.properties.Nazwa + '</div>';

            let customOptions = {
                'maxHeight': '450',
                'className': 'custom__zoo'
            };
            layer.bindPopup(popupContent, customOptions);
        }


        function styleMarkers(currentZoom) {
            console.log(currentZoom);
            let markerPane = document.querySelector(".leaflet-marker-pane");
            if (currentZoom <= 10) {
                markerPane.classList.add('s0');
                markerPane.classList.remove('s1');
                markerPane.classList.remove('s2');
            } else if (currentZoom > 10 && currentZoom <= 12) {
                markerPane.classList.remove('s0');
                markerPane.classList.add('s1');
                markerPane.classList.remove('s2');
            } else if (currentZoom > 12 && currentZoom <= 14) {
                markerPane.classList.remove('s0');
                markerPane.classList.remove('s1');
                markerPane.classList.add('s2');
            } else {
                markerPane.classList.remove('s0');
                markerPane.classList.remove('s1');
                markerPane.classList.remove('s2');
            }
        };

        function zoomStyleLayers(currentZoom) {
            // map.addLayer(gm_name);
            let labels = document.querySelectorAll('.labelClass span');

            if (currentZoom < 10) {
                labels.forEach(function (element) {
                    element.style.fontSize = "5.5px";
                });
            } else if (currentZoom >= 10 && currentZoom < 11) {
                labels.forEach(function (element) {
                    element.style.fontSize = "8.5px";
                });
            } else if (currentZoom >= 11 && currentZoom < 12) {
                labels.forEach(function (element) {
                    element.style.fontSize = "11.5px";
                });
            } else if (currentZoom >= 12 && currentZoom < 13) {
                labels.forEach(function (element) {
                    element.style.fontSize = "14px";
                });
            } else if (currentZoom >= 13 && currentZoom < 14) {
                labels.forEach(function (element) {
                    element.style.fontSize = "18px";
                });
            } else if (currentZoom >= 14 && currentZoom < 15) {
                labels.forEach(function (element) {
                    element.style.fontSize = "22px";
                });
            } else if (currentZoom >= 15 && currentZoom < 16) {
                labels.forEach(function (element) {
                    element.style.fontSize = "26px";
                });
            } else if (currentZoom >= 16) {
                labels.forEach(function (element) {
                    element.style.fontSize = "30px";
                });
            } else {
                labels.forEach(function (element) {
                    element.style.fontSize = "8px";
                });
            }
            ;
        };
        styleMarkers(map.getZoom());
        if (map.hasLayer(gzmLabels)) {
            zoomStyleLayers(map.getZoom());
        }
        ;


        /**
         * Function open popup when marker hovered
         * @param {event} e
         */
        function highlightFeaturePark(e) {
            highlightPopPark = e.target;
            highlightPopPark.openPopup();
        }

        /**
         *
         * @param {string} str
         * @returns
         */
        function stringToHTML(string) {
            let parser = new DOMParser();
            let doc = parser.parseFromString(string, 'text/html');
            // console.log(doc.body.querySelector('.c-park-details'));
            return doc.body.querySelector('.c-park-details');
        };

        let IconStyleTwo = L.icon({
            iconUrl: '/wp-content/themes/infogzm/img/icons/info-icon3.png',
            iconAnchor: [13, 40],
            popupAnchor: [110, -20],
            iconSize: [26, 40],
            className: 'marker_park1'
        });
        let IconStyleOne = L.icon({
            iconUrl: '/wp-content/themes/infogzm/img/icons/marker-green.png',
            iconAnchor: [13, 40],
            popupAnchor: [110, -20],
            iconSize: [26, 40],
            className: 'marker_park'
        });

        /**
         * Function sending AJAX request when marker on map is cliked
         * @param {event} e
         */
        function clickFeaturePark(e) {

            if (highlightedMarker !== null) {
                highlightedMarker.setIcon(IconStyleOne);
                highlightedMarker = null;
            }
            // console.log(e.target.feature.properties.id);
            e.target.setIcon(IconStyleTwo);
            highlightedMarker = e.target;

            block.querySelector('.block-greengzm-map__sidebar').classList.add('active');
            block.querySelector('.block-greengzm-map__sidebarOpen').classList.add('active');
            block.querySelector('.block-greengzm-map__sidebar').scrollTop = 0;
            block.querySelector('.sidebar__inner').classList.add('sidebar__inner--loading');

            wp.ajax.post("greengzm_map_sidebar", {
                'security': phpvars.security,
                'postid': e.target.feature.properties.id

            })
                .done((r) => {
                    block.querySelector('.ajax-load-post').replaceChildren(stringToHTML(r));
                    block.querySelector('.sidebar__inner').classList.remove('sidebar__inner--loading');

                })
                .fail((r) => {
                    console.warn('failed AJAX');
                    block.querySelector('.sidebar__inner').classList.remove('sidebar__inner--loading');

                });
        }

        /**
         *
         * @param {string} layers
         * @param {boolean} status
         */
        function updateLayer(layers, status) {
            if (status) {
                layers.forEach(layer => {
                    let layerName = layer.split('|')[0];
                    let paneName = layer.split('|')[1] ? layer.split('|')[1] : 'wms';
                    // let obj = L.tileLayer('');
                    // map.addLayer(obj);
                    // let obj = L.tileLayer.betterWms('https://infogzm.metropoliagzm.pl/mapy/get_tile.php?', {
                    //     layers: layerName,
                    //     format: "image/png",
                    //     transparent: true,
                    //     maxZoom: 20,
                    //     tileSize: 256,
                    //     pane: paneName
                    // });
                    let obj;
                    if(["gzm:PN_Rez","gzm:03_Parki_Krajobrazowe","gzm:04_Obszary_Chronionego_Krajobrazu","gzm:05a_Obszary_Specjalnej_Ochrony","gzm:05b_Specjalne_Obszary_Ochrony","gzm:UE_SD_ZPK"].includes(layerName)){
                        obj = L.tileLayer.betterWms("https://infogzm.metropoliagzm.pl//iframes/tiles/get_tile.php?",{
                            layers: layerName,
                            format: "image/png",
                            transparent: true,
                            maxZoom: 20,
                            tileSize: 256,
                            pane: paneName,
                            interactive: true
                        });
                        obj.on('mouseover', function (e) {
                                console.log('wjazd');
                        });
                        // obj.on({
                        //     mouseout: function (e) {
                        //         console.log('zjazd');
                        //     },
                        //     mouseover:  function (e) {
                        //         console.log('wjazd');
                        //     },
                        // });

                        // obj.getContainer().setAttribute('id', 'wmsContainer');

                    } else {
                        obj = L.tileLayer.wms("https://infogzm.metropoliagzm.pl//iframes/tiles/get_tile.php?",{
                            layers: layerName,
                            format: "image/png",
                            transparent: true,
                            maxZoom: 20,
                            tileSize: 256,
                            pane: paneName
                        });
                    }


                    console.log(obj);

                    map.addLayer(obj);
                    activeLayers.set(layerName, obj._leaflet_id);
                });
            } else {
                layers.forEach(layer => {
                    let layerName = layer.split('|')[0];
                    let toRemove;
                    map.eachLayer(function (el) {
                        if (el._leaflet_id == activeLayers.get(layerName)) {
                            toRemove = el;
                        }
                    });
                    if (toRemove) {
                        map.removeLayer(toRemove);
                        activeLayers.delete(layerName)
                    }
                });
            }
        }

        function updateMarkers(event) {
            let status = event.target.checked;
            let markers = event.target.getAttribute('name').split(':')[1];
            if (status) {
                switch (markers) {
                    case 'Skwery':
                        pkt_skwer.eachLayer(function (layer) {
                            layer._icon.style.display = 'block';
                        });
                        break;
                    case 'Zoo':
                        pkt_zoo.eachLayer(function (layer) {
                            layer._icon.style.display = 'block';
                        });
                        break;
                }
            } else {
                switch (markers) {
                    case 'Skwery':
                        pkt_skwer.eachLayer(function (layer) {
                            layer._icon.style.display = 'none';
                        });
                        break;
                    case 'Zoo':
                        pkt_zoo.eachLayer(function (layer) {
                            layer._icon.style.display = 'none';
                        });
                        break;
                }
            }

        }

        /**
         * Changing visibility of addicional layers on map
         * @param {event} event
         */
        function changeLayerStatus(event) {
            let status = event.target.checked;
            let layers = event.target.getAttribute('name').split(';');
            updateLayer(layers, status);
        }

        function filterMarkersByName(element) {
            if (!showParks) {
                return;
            }
            let name = element.value;
            if (name.length == 0) {
                pkt_park.clearLayers();
                pkt_park = new L.geoJson(markersData, {
                    pane: 'ovl',
                    onEachFeature: pop_pkt_park,
                    pointToLayer: function (feature, latlng) {
                        let context = {
                            feature: feature,
                            variables: {}
                        };
                        return L.marker(latlng, marker_park(feature));
                    },
                }).addTo(map);
            } else if (name.length < 3) {
                return;
            } else {
                document.querySelector('.js-control__ajax').classList.add('control__wrapper--loading');
                element.setAttribute('disabled', true);
                wp.ajax.post("greengzm_search_name", {
                    'security': phpvars.security,
                    'search': name
                })
                    .done((response) => {
                        clearTimeout(timer);
                        pkt_park.clearLayers();

                        pkt_park = new L.geoJson(response, {
                            pane: 'ovl',
                            onEachFeature: pop_pkt_park,
                            pointToLayer: function (feature, latlng) {
                                let context = {
                                    feature: feature,
                                    variables: {}
                                };
                                return L.marker(latlng, marker_park(feature));
                            },
                        }).addTo(map);

                        element.removeAttribute('disabled');
                        document.querySelector('.js-control__ajax').classList.remove('control__wrapper--loading');


                    })
                    .fail((response) => {
                        console.warn('failed AJAX');
                        console.log(response);
                        document.querySelector('.js-control__ajax').classList.remove('control__wrapper--loading');

                    });
            }
        }


        function filterMarkersByAttr() {

            if (!showParks) {
                return;
            }
            let minSurface = 0;
            let maxSurface = 9999;
            let attractions = [];

            let attractionItems = document.getElementsByName('attractions');
            attractionItems.forEach(attractionItem => {
                if (attractionItem.checked) {
                    attractions.push(attractionItem.value);
                }
            });
            if (document.getElementById('minSurface').selectedIndex != 0) {
                minSurface = parseInt(document.getElementById('minSurface').value);
            }
            if (document.getElementById('maxSurface').selectedIndex != 0) {
                maxSurface = parseInt(document.getElementById('maxSurface').value);
            }

            document.querySelector('.js-control__ajax').classList.add('control__wrapper--loading');

            wp.ajax.post("greengzm_search_attrs", {
                'security': phpvars.security,
                'minSurface': minSurface,
                'maxSurface': maxSurface,
                'attractions': attractions
            })
                .done((response) => {
                    // console.log(response);
                    pkt_park.clearLayers();
                    pkt_park = new L.geoJson(response, {
                        pane: 'ovl',
                        onEachFeature: pop_pkt_park,
                        pointToLayer: function (feature, latlng) {
                            let context = {
                                feature: feature,
                                variables: {}
                            };
                            return L.marker(latlng, marker_park(feature));
                        },
                    }).addTo(map);
                    document.querySelector('.js-control__ajax').classList.remove('control__wrapper--loading');

                })
                .fail((response) => {
                    console.warn('failed AJAX');
                    console.log(response);
                    document.querySelector('.js-control__ajax').classList.remove('control__wrapper--loading');

                });
        }

        function resetFilters() {
            if (!showParks) {
                return;
            }
            document.getElementById('maxSurface').selectedIndex = 0;
            document.getElementById('minSurface').selectedIndex = 0;

            let parametersInputs = block.querySelectorAll('[data-filter="parameters"] input:not([type="radio"])');
            parametersInputs.forEach(parametersInput => {
                parametersInput.checked = false;
            });

            pkt_park.clearLayers();
            pkt_park = new L.geoJson(markersData, {
                pane: 'ovl',
                onEachFeature: pop_pkt_park,
                pointToLayer: function (feature, latlng) {
                    let context = {
                        feature: feature,
                        variables: {}
                    };
                    return L.marker(latlng, marker_park(feature));
                },
            }).addTo(map);
        }

        function switchFilters(element) {
            console.log(element);
            if (element == 'name') {
                document.getElementById('filterByName').removeAttribute('disabled');

                let parametersInputs = block.querySelectorAll('[data-filter="parameters"] input:not([type="radio"])');
                parametersInputs.forEach(parametersInput => {
                    parametersInput.setAttribute('disabled', true);
                });
                let parametersBtns = block.querySelectorAll('[data-filter="parameters"] button');
                parametersBtns.forEach(parametersBtn => {
                    parametersBtn.setAttribute('disabled', true);
                });
                let parametersSelects = block.querySelectorAll('[data-filter="parameters"] select');
                parametersSelects.forEach(parametersSelect => {
                    parametersSelect.setAttribute('disabled', true);
                });

            } else {
                document.getElementById('filterByName').setAttribute('disabled', true);

                let parametersInputs = block.querySelectorAll('[data-filter="parameters"] input:not([type="radio"])');
                parametersInputs.forEach(parametersInput => {
                    parametersInput.removeAttribute('disabled');
                });
                let parametersBtns = block.querySelectorAll('[data-filter="parameters"] button');
                parametersBtns.forEach(parametersBtn => {
                    parametersBtn.removeAttribute('disabled');
                });
                let parametersSelects = block.querySelectorAll('[data-filter="parameters"] select');
                parametersSelects.forEach(parametersSelect => {
                    parametersSelect.removeAttribute('disabled');
                });
            }
        }

        function parksVisibility(status) {
            showParks = status;
            if (status) {
                document.getElementById('maxSurface').selectedIndex = 0;
                document.getElementById('minSurface').selectedIndex = 0;
                document.getElementById('filterByName').value = "";
                let parametersInputs = block.querySelectorAll('[data-filter="parameters"] input:not([type="radio"])');
                parametersInputs.forEach(parametersInput => {
                    parametersInput.checked = false;
                });
                pkt_park = new L.geoJson(markersData, {
                    pane: 'ovl',
                    onEachFeature: pop_pkt_park,
                    pointToLayer: function (feature, latlng) {
                        let context = {
                            feature: feature,
                            variables: {}
                        };
                        return L.marker(latlng, marker_park(feature));
                    },
                }).addTo(map);
            } else {
                pkt_park.clearLayers();
            }
        }

        function switchMapBackground(mapBg) {
            // console.log(mapBg);
            if (mapBg == 'CartoDb') {
                map.removeLayer(GoogleSatellite);
                map.addLayer(CartoDb);
                gzm.resetStyle();
                wojThin.resetStyle();
                document.getElementsByName('gzm:wody|waters;gzm:Tereny|woj')[0].checked = true;
                updateLayer(['gzm:wody|waters', 'gzm:Tereny|woj'], true);
            } else {
                map.addLayer(GoogleSatellite);
                map.removeLayer(CartoDb);
                document.getElementsByName('gzm:wody|waters;gzm:Tereny|woj')[0].checked = false;
                updateLayer(['gzm:wody|waters', 'gzm:Tereny|woj'], false);
                gzm.setStyle({
                    color: "#FFF"
                });
                wojThin.setStyle({
                    color: "#FFF"
                });
            }
        }


        let layerSelectors = block.querySelectorAll('[name^="gzm:"]');
        layerSelectors.forEach(layerSelector => {
            layerSelector.addEventListener('change', changeLayerStatus);
            if (layerSelector.checked) {
                updateLayer(layerSelector.getAttribute('name').split(';'), true);
            }
        });

        let pointsSelectors = block.querySelectorAll('[name^="markers:"]');
        pointsSelectors.forEach(pointsSelector => {
            pointsSelector.addEventListener('change', updateMarkers);

            // updateMarkers(pointsSelector.getAttribute('name').split(':')[1], pointsSelector.checked);
        });

        let filterByName = block.querySelector('#filterByName');
        filterByName.addEventListener('input', event => {
            if (timer != undefined) {
                clearTimeout(timer);
            }
            timer = setTimeout(filterMarkersByName, 500, event.target);
        });

        const filterSwitcher = document.getElementsByName('filter');
        filterSwitcher.forEach(filterSwitch => {
            filterSwitch.addEventListener('change', (event) => {
                switchFilters(event.target.value);
            });
        });

        const mapBackgroundSwitchers = document.getElementsByName('mapBG');
        mapBackgroundSwitchers.forEach(mapBackgroundSwitcher => {
            mapBackgroundSwitcher.addEventListener('change', (event) => {
                switchMapBackground(event.target.value);
            });
        });

        const parksMarkersSwitcher = document.getElementById('parksMarkersSwitcher');
        parksMarkersSwitcher.addEventListener('change', (event) => {
            parksVisibility(event.target.checked);
        });

        let filterByAttrBtn = document.getElementById(block.id + '_filterBtn');
        filterByAttrBtn.addEventListener('click', filterMarkersByAttr);

        let resetByAttrBtn = document.getElementById(block.id + '_resetBtn');
        resetByAttrBtn.addEventListener('click', resetFilters);

        const communityBordersBtn = document.getElementById('communityBorders');
        communityBordersBtn.addEventListener('change', (event) => {
            if (event.target.checked) {
                map.addLayer(gzm);
                if (document.getElementById('mapBG_GoogleSatellite').checked) {
                    gzm.setStyle({
                        color: "#FFF"
                    });
                }
            } else {
                map.removeLayer(gzm);

            }
        });


        const communityNamesBtn = document.getElementById('communityNames');
        communityNamesBtn.addEventListener('change', (event) => {
            if (event.target.checked) {
                map.addLayer(gzmLabels);
            } else {
                map.removeLayer(gzmLabels);

            }
        });

        const controlPanels = document.querySelectorAll('.control__open');
        controlPanels.forEach(controlPanel => {
            controlPanel.addEventListener('click', (event) => {

                let restGroups = document.querySelectorAll('.control__group--open');
                console.log(restGroups);
                restGroups.forEach((group)=>{
                    console.log(group);
                    if( !group.classList.contains('control__group--dock') ){
                        group.classList.remove('control__group--open');
                        group.querySelector('.control__wrapper').classList.remove('control__wrapper--opened');
                        // group.querySelector('.control__wrapper').style.maxHeight = 0;
                    }
                });

                event.target.parentElement.classList.add('control__group--open');
                let wrapper = event.target.parentElement.querySelector('.control__wrapper');
                // wrapper.style.maxHeight = wrapper.scrollHeight + 10 + "px";
                wrapper.classList.add('control__wrapper--opened');
            });
        });

        const minimizePanels = document.querySelectorAll('.js-controlMinimize');
        minimizePanels.forEach(minimizePanel => {
            minimizePanel.addEventListener('click', (event) => {
                let openedPanel = event.target.closest('.control__group');
                openedPanel.classList.remove('control__group--open');
                openedPanel.querySelector('.control__wrapper').classList.remove('control__wrapper--opened');
                // openedPanel.querySelector('.control__wrapper').style.maxHeight = 0;
            });
        });


        map.addEventListener('zoomend', function () {
            styleMarkers(map.getZoom());
            if (map.hasLayer(gzmLabels)) {
                zoomStyleLayers(map.getZoom());
            }
            ;
        });

        // L.control.layers(baseLayers).addTo(map);
    };


    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if (blocks.length > 0) {
            blocks.forEach((block) => {
                initializeBlock(block);
            });
        }
    };


    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);


    // ACF Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }
    });
})();
